import * as THREE from "three";

const VEC3_POOL_SIZE = 32;
const QUAT_POOL_SIZE = 16;
const MAT4_POOL_SIZE = 8;

const vec3Pool: THREE.Vector3[] = [];
const quatPool: THREE.Quaternion[] = [];
const mat4Pool: THREE.Matrix4[] = [];

let vec3Idx = 0;
let quatIdx = 0;
let mat4Idx = 0;

for (let i = 0; i < VEC3_POOL_SIZE; i++) vec3Pool.push(new THREE.Vector3());
for (let i = 0; i < QUAT_POOL_SIZE; i++) quatPool.push(new THREE.Quaternion());
for (let i = 0; i < MAT4_POOL_SIZE; i++) mat4Pool.push(new THREE.Matrix4());

export const TempVec = {
  vec3(): THREE.Vector3 {
    const v = vec3Pool[vec3Idx]!;
    vec3Idx = (vec3Idx + 1) % VEC3_POOL_SIZE;
    return v.set(0, 0, 0);
  },
  quat(): THREE.Quaternion {
    const q = quatPool[quatIdx]!;
    quatIdx = (quatIdx + 1) % QUAT_POOL_SIZE;
    return q.identity();
  },
  mat4(): THREE.Matrix4 {
    const m = mat4Pool[mat4Idx]!;
    mat4Idx = (mat4Idx + 1) % MAT4_POOL_SIZE;
    return m.identity();
  },
};
